/**
 * Icona notifiche OS: usa QWEB.png (stesso file dell'header qcenter)
 * adattato in canvas quadrato per evitare tagli del sistema operativo.
 */

let cachedIconUrl = null;
let preparePromise = null;

function getFallbackSquareIconUrl(sourceUrl) {
    return sourceUrl.replace(/QWEB\.png(?:\?.*)?$/i, 'QWEB-notification.png');
}

export function getQwebNotificationSourceUrl(baseUrl) {
    const base = (baseUrl || '').replace(/\/+$/, '');
    if (!base) {
        return `${process.env.PUBLIC_URL || ''}/brand/QWEB.png`;
    }

    return `${base}/brand/QWEB.png`;
}

export function prepareQwebNotificationIcon(sourceUrl) {
    if (cachedIconUrl) {
        return Promise.resolve(cachedIconUrl);
    }

    if (preparePromise) {
        return preparePromise;
    }

    const fallbackUrl = getFallbackSquareIconUrl(sourceUrl);

    preparePromise = new Promise((resolve) => {
        if (typeof document === 'undefined') {
            cachedIconUrl = fallbackUrl;
            resolve(cachedIconUrl);
            return;
        }

        const img = new Image();
        img.crossOrigin = 'anonymous';

        img.onload = () => {
            try {
                const width = img.naturalWidth;
                const height = img.naturalHeight;
                const base = Math.max(width, height);
                const padding = Math.max(24, Math.round(base * 0.10));
                const canvasSize = base + padding * 2;
                const canvas = document.createElement('canvas');
                canvas.width = canvasSize;
                canvas.height = canvasSize;

                const ctx = canvas.getContext('2d');
                ctx.clearRect(0, 0, canvasSize, canvasSize);
                ctx.drawImage(
                    img,
                    (canvasSize - width) / 2,
                    (canvasSize - height) / 2
                );

                cachedIconUrl = canvas.toDataURL('image/png');
                resolve(cachedIconUrl);
            } catch (error) {
                cachedIconUrl = fallbackUrl;
                resolve(cachedIconUrl);
            }
        };

        img.onerror = () => {
            cachedIconUrl = fallbackUrl;
            resolve(cachedIconUrl);
        };

        img.src = sourceUrl;
    });

    return preparePromise;
}

export function getPreparedQwebNotificationIconUrl(fallbackSourceUrl) {
    return cachedIconUrl || getFallbackSquareIconUrl(fallbackSourceUrl);
}
